$.fn.timepicker.defaults = $.extend(true, {}, $.fn.timepicker.defaults, {
    icons: {
        up: 'la la-angle-up',
        down: 'la la-angle-down'  
    }
});


// WEBPACK FOOTER //
// src/assets/metronic/src/js/framework/components/plugins/forms/bootstrap-timepicker.init.js